<template>
  <div>
    <!-- Vista no admin -->
    <span
      v-if="!userStore.isAdmin"
      :class="{ 'text-cancel': state === 'canceled' }"
    >
      {{ calculateState(interval) }}
    </span>

    <!-- Select custom (dropdown estilizado) -->
    <b-dropdown
      v-else
      size="sm"
      variant="light"
      class="state-select-dropdown"
      :disabled="isDisable"
      no-caret
    >
      <!-- Valor seleccionado -->
      <template #button-content>
        <span class="state-select-value">
          <span :class="['state-dot', currentDotClass]"></span>
          {{ currentLabel }}
        </span>
        <i class="isax isax-arrow-down-1"></i>
      </template>

      <!-- Opciones -->
      <b-dropdown-item @click="onSelect('active')">
        <span class="state-select-option">
          <span class="state-dot dot-active"></span>
          {{ $t("reviews.intervals.active") }}
        </span>
      </b-dropdown-item>

      <b-dropdown-item @click="onSelect('locked')">
        <span class="state-select-option">
          <span class="state-dot dot-locked"></span>
          {{ $t("reviews.intervals.locked") }}
        </span>
      </b-dropdown-item>

      <b-dropdown-item @click="onSelect('canceled')">
        <span class="state-select-option">
          <span class="state-dot dot-canceled"></span>
          {{ $t("reviews.intervals.canceled") }}
        </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ServiceInterval from "@/service/intervals.js";
import useUserState from "@/store/userState";

export default {
  name: "MultiselectState",
  props: ["interval", "state", "isDisable"],

  data() {
    return {
      userStore: useUserState(),
      states_selected: this.state,
    };
  },

  computed: {
    currentLabel() {
      return this.$t(`reviews.intervals.${this.states_selected}`);
    },

    currentDotClass() {
      return {
        active: "dot-active",
        locked: "dot-locked",
        canceled: "dot-canceled",
      }[this.states_selected];
    },
  },

  methods: {
    calculateState(interval) {
      if (interval.canceled) {
        return i18n.t("reviews.intervals.canceled");
      } else if (interval.locked) {
        return i18n.t("reviews.intervals.locked");
      } else {
        return i18n.t("reviews.intervals.active");
      }
    },

    async onSelect(value) {
      const oldValue = this.states_selected;
      this.states_selected = value;

      let success = false;

      if (value === "canceled") {
        try {
          const resp = await this.$bvModal.msgBoxConfirm(
            i18n.t("reviews.intervals.cancel-msg"),
            {
              title: i18n.t("reviews.intervals.cancel-title"),
              buttonSize: "sm",
              okTitle: i18n.t("reviews.intervals.cancel-ok"),
              headerClass: "header-modal-cancel",
              cancelVariant: "cancel-header-button",
              okVariant: "ok-header-button",
              cancelTitle: i18n.t("reviews.intervals.cancel-no"),
              footerClass: "p-2 d-flex justify-content-between",
              centered: true,
            }
          );

          if (resp) {
            success = await this.changeStateInterval(value);
          } else {
            this.states_selected = oldValue;
          }
        } catch (err) {
          this.$noty.error(err);
        }
      } else {
        success = await this.changeStateInterval(value);
      }

      if (!success) {
        this.states_selected = oldValue;
      }
    },

    async changeStateInterval(state) {
      let success = false;

      this.$set(this.interval, "canceled", state === "canceled");
      this.$set(this.interval, "locked", state === "locked");

      const dto = {
        id: this.interval.id,
        locked: this.interval.locked,
        canceled: this.interval.canceled,
      };

      await ServiceInterval.putIntervals(
        this.interval.reviewId,
        this.interval.id,
        dto
      )
        .then((response) => {
          if (response && response.status === 200) {
            success = true;
            this.$noty.success(
              i18n.t("reviews.intervals.change-success", {
                timeout: 3000,
                progressBar: true,
              })
            );
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.$emit("reloadIntervalTable");
          }, 300);
        });

      return success;
    },
  },
};
</script>
